




































import Vue from 'vue'
export default Vue.extend({
  name: 'InputField',
  props: {
    value: {
      required: true,
      type: String
    },
    type: {
      type: String,
      default: 'default'
    },
    noValidate: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldName: String,
    title: String,
    placeholder: String,
    passwordField: Boolean,
    displayPasswordToggle: Boolean,
    disabled: Boolean,
    required: Boolean,
    minlength: Number,
    maxlength: Number,
    pattern: String,
    min: Number,
    max: Number
  },
  data: function () {
    return ({
      showPassword: false,
      visibilityToggleWidth: 0,
      error: ''
    })
  },
  computed: {
    inputType (): string {
      if (!this.passwordField) {
        return 'text'
      }
      return this.showPassword ? 'text' : 'password'
    }
  },
  methods: {
    toggleVisibility (): void {
      this.showPassword = !this.showPassword
      if (this.displayPasswordToggle) {
        this.$nextTick(() => {
          this.visibilityToggleWidth = (this.$refs && this.$refs.visibilityToggle
            ? (this.$refs.visibilityToggle as HTMLDivElement).getBoundingClientRect().width
            : 0)
        })
      }
    }
  },
  mounted: function () {
    if (this.displayPasswordToggle) {
      this.$nextTick(() => {
        this.visibilityToggleWidth = (this.$refs && this.$refs.visibilityToggle
          ? (this.$refs.visibilityToggle as HTMLDivElement).getBoundingClientRect().width
          : 0)
      })
    }
  }
})
